import "./Partner.css";

export default function Partner({ partner, index }) {
    return (
        <div
            className="partner-block"
            style={{ justifyContent: index % 2 === 0 ? "flex-start" : "flex-end" }}
            role="listitem"
        >
            <div className="partner-image">
                <img
                    loading="lazy"
                    decoding="async"
                    src={partner.image}
                    alt={partner.name || "Logo partnera"}
                    draggable="false"
                    width="180"
                    height="80"
                    style={{ objectFit: "contain", display: "block" }}
                />
            </div>
            {/* <span className="partner-label">{partner.name}</span> */}
        </div>
    );
}
